import Reveal from '../../../shared/Reveal/Reveal';
import { usePlatformsMetaTraderContent } from '../../../../hooks/usePlatformsMetaTraderContent';
import mainImage from '../../../../assets/images/platforms/metatrader/main.png';
import appleLogo from '../../../../assets/images/platforms/metatrader/AppleLogo.svg';
import windowsLogo from '../../../../assets/images/platforms/metatrader/WindowsLogo.svg';
import appStoreLogo from '../../../../assets/images/platforms/metatrader/AppStoreLogo.svg';
import googlePlayLogo from '../../../../assets/images/platforms/metatrader/GooglePlayLogo.svg';
import './MetaTrader.css';

const fallbackIcons = [appleLogo, windowsLogo, appStoreLogo, googlePlayLogo];

const MetaTrader = () => {
  const { content, isLoading } = usePlatformsMetaTraderContent();

  if (isLoading || !content) {
    return null;
  }

  const { title, text, image, downloads } = content;

  return (
    <section className="platforms-metatrader">
      <div className="platforms-metatrader__inner">
        <Reveal className="platforms-metatrader__copy">
          <h2 className="platforms-metatrader__title">{title}</h2>
          {text ? <p className="platforms-metatrader__text">{text}</p> : null}
        </Reveal>

        <Reveal className="platforms-metatrader__downloads" delay={80}>
          {downloads.map(({ label, icon, href }, index) => (
            <a
              key={label}
              href={href}
              className="platforms-metatrader__download"
            >
              <img
                className="platforms-metatrader__download-icon"
                src={icon || fallbackIcons[index]}
                alt=""
                aria-hidden="true"
              />
              {label}
            </a>
          ))}
        </Reveal>
      </div>

      <div className="platforms-metatrader__media">
        <img
          className="platforms-metatrader__image"
          src={image || mainImage}
          alt=""
          aria-hidden="true"
        />
      </div>
    </section>
  );
};

export default MetaTrader;
